import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { Form } from '../../../../../form-engine/components/Form';
import type { ProductType } from '../../../../../types';
import {
  useQuoteDynamicForm,
  useQuoteDynamicFormId,
} from '../../../../../components/hooks/queries/forms/useDynamicForm';
import { useSaveQuoteDynamicFields } from '../../../../../components/hooks/forms/useSaveQuoteDynamicFields';

type QuoteDynamicSecurityAssessmentFormProps = {
  productType: ProductType;
  quoteId: string;
  accountId: string;
  isEditable: boolean;
  withDefaults?: boolean;
};

export const QuoteDynamicSecurityAssessmentForm = (
  props: QuoteDynamicSecurityAssessmentFormProps
) => {
  const queryClient = useQueryClient();
  const { saveQuoteDynamicFields } = useSaveQuoteDynamicFields({
    quoteId: props.quoteId,
    productType: props.productType,
  });

  const handleSubmitSuccess = React.useCallback(() => {
    queryClient.invalidateQueries({
      queryKey: ['dynamic-form', { quoteId: props.quoteId }],
    });
  }, [queryClient, props.quoteId]);

  const { data: formId } = useQuoteDynamicFormId({
    quoteId: props.quoteId,
  });
  const quoteFormSchemaQuery = useQuoteDynamicForm({
    quoteId: props.quoteId,
    formId,
    withDefaults: props.withDefaults,
  });

  return (
    <Form
      accountId={props.accountId}
      formId={formId}
      formSchemaQuery={quoteFormSchemaQuery}
      onSubmit={saveQuoteDynamicFields}
      onSubmitSuccess={handleSubmitSuccess}
      productType={props.productType}
      disabled={!props.isEditable}
      Actions={props.isEditable ? undefined : () => null}
      useDefaultValuesFromFormSchema={false}
    />
  );
};
